// EIP-712 signing for Hyperliquid agent-wallet onboarding. Wallet connection
// itself lives in `@/lib/wallet/connect.ts`, shared with Derive's session-key
// onboarding — this file only has the Hyperliquid-specific typed-data signing
// call left in it.
import { assertManualWalletAction, getWalletProvider } from '@/lib/wallet/connect'

export { connectWallet, getChainId } from '@/lib/wallet/connect'

/** Sign a backend-supplied EIP-712 typed-data payload (JSON string) verbatim. */
export async function signTypedDataPayload(address: string, payloadJson: string): Promise<string> {
  assertManualWalletAction()
  const provider = await getWalletProvider()
  const signature = await provider.request({
    method: 'eth_signTypedData_v4',
    params: [address as `0x${string}`, payloadJson],
  })
  return signature as string
}
